import { createFileRoute } from "@tanstack/react-router";
import { AccountShell } from "@/components/customer/AccountShell";
import { useAppointmentDetails } from "@/hooks/useAppointments";
import { formatISTDateTime } from "@/lib/date/ist";
import { Badge } from "@/components/ui/badge";
import { Loader2, ArrowLeft } from "lucide-react";
import { Link } from "@tanstack/react-router";

export const Route = createFileRoute("/_customer/account/appointments/$appointmentId")({
  component: AppointmentDetailsPage,
});

function AppointmentDetailsPage() {
  const { appointmentId } = Route.useParams();
  const { data: apt, isLoading } = useAppointmentDetails(appointmentId);

  if (isLoading) {
    return (
      <AccountShell title="Appointment Details">
        <div className="flex justify-center p-12">
          <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
        </div>
      </AccountShell>
    );
  }

  if (!apt) {
    return (
      <AccountShell title="Appointment Details">
        <div className="p-8 text-center text-sm text-muted-foreground">
          Appointment not found.
        </div>
      </AccountShell>
    );
  }

  return (
    <AccountShell title={apt.reference}>
      <Link
        to="/account/appointments"
        className="mb-6 inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground"
      >
        <ArrowLeft className="h-4 w-4" />
        Back to list
      </Link>

      <div className="grid gap-8">
        <section className="rounded-xl border border-border/60 bg-card p-6">
          <div className="mb-4 flex items-center justify-between">
            <h2 className="text-lg font-medium">{(apt.consultation_types as any)?.name}</h2>
            <Badge className="uppercase">{apt.status}</Badge>
          </div>
          <dl className="grid gap-x-4 gap-y-6 sm:grid-cols-2">
            <div>
              <dt className="text-xs uppercase tracking-wider text-muted-foreground">Consultant</dt>
              <dd className="mt-1 font-medium">{(apt.consultants as any)?.name}</dd>
            </div>
            <div>
              <dt className="text-xs uppercase tracking-wider text-muted-foreground">Date & Time</dt>
              <dd className="mt-1 font-medium">{formatISTDateTime(apt.start_time)}</dd>
            </div>
          </dl>
        </section>

        {(apt.consultation_notes as any)?.[0]?.customer_recommendations && (
          <section className="rounded-xl border border-primary/20 bg-primary/5 p-6">
            <h2 className="mb-3 text-lg font-medium text-primary">Recommendations</h2>
            <div className="prose prose-sm text-foreground/80">
              {(apt.consultation_notes as any)[0].customer_recommendations}
            </div>
          </section>
        )}
      </div>
    </AccountShell>
  );
}
